import { FormFieldWrapper } from "components/forms/part/FormFieldWrapper/FormFieldWrapper";
import { FormFreeTextProps } from "components/forms/part/FormFreeText/types";
import { FormInputWrapper } from "components/forms/part/FormInputWrapper/FormInputWrapper";
import { FormLabel } from "components/forms/part/FormLabel/FormLabel";
import { Component } from "react";
import t from "translations/translator";
import utils from "util/utils";

export class FormFreeText extends Component<FormFreeTextProps> {
	render():JSX.Element{
		const label = this.props.label;
		const freeText = this.props.input;
		const dataAttrs = this.props.input.dataAttributes ? utils.helpers.convertToDataAttributes(this.props.input.dataAttributes) : null;
		const freeTextClass = freeText.class ? freeText.class : [];

		freeTextClass.push("field-free-text");

		return (
			<FormFieldWrapper label={label} minimalist={false} width={this.props.fieldWidth}>
				<FormLabel {...this.props.label} />
				<FormInputWrapper>
					<p
						className={freeTextClass.join(" ")}
						{...dataAttrs}
					>
						{freeText.translate === false ? freeText.text : t.t(freeText.text, freeText.placeholders)}
					</p>
				</FormInputWrapper>
			</FormFieldWrapper>
		);
	}
}
